module.exports = __webpack_public_path__ + "img/Sign_8.288ee46b.png";